// Limits a products query to the country the customer picked with the flag toggle.
// Products with no country set are treated as UK products, so nothing disappears by accident.
export function applyCountryFilter(query, country) {
  if (country === "Nigeria") {
    return query.ilike("country", "Nigeria");
  }
  return query.or("country.is.null,country.ilike.UK");
}